"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = exports.default = void 0;
var _react = require("react");
var _css = require("@emotion/css");
var _CetComponentsProvider = require("../../providers/CetComponentsProvider");
var _hooks = require("../../hooks");
const useStyles = props => {
  const {
    borderRadius = {}
  } = props;
  const {
    fontFamily,
    themeColors
  } = (0, _react.useContext)(_CetComponentsProvider.CetComponentsContext);
  const {
    borderRadiusProps
  } = (0, _hooks.useStylesUtils)();
  const ccRichTextEditorStyle = (0, _react.useMemo)(() => {
    const ccRichTextEditor = (0, _css.css)({
      fontFamily: fontFamily,
      userSelect: 'none',
      position: 'relative',
      width: '100%',
      height: '100%',
      textarea: {
        display: 'none'
      },
      '&>div:first-of-type': {
        border: `1px solid ${themeColors?.general.border}`,
        overflow: 'hidden',
        boxSizing: 'border-box',
        ...borderRadiusProps(borderRadius)
      }
    });
    const ccRichTextEditorBody = (0, _css.css)({
      fontFamily: fontFamily,
      color: themeColors?.general.text
    });
    return {
      ccRichTextEditor,
      ccRichTextEditorBody
    };
  }, [borderRadius, borderRadiusProps, fontFamily, themeColors?.general.border, themeColors?.general.text]);
  return {
    'cc-RichTextEditor': ccRichTextEditorStyle.ccRichTextEditor,
    'cc-RichTextEditor__body': ccRichTextEditorStyle.ccRichTextEditorBody
  };
};
exports.useStyles = useStyles;
var _default = exports.default = useStyles;